import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useAuth } from 'src/contexts/auth'
import { GenotypingController } from 'src/controllers/genotyping.controller'

const genotypingController = new GenotypingController()

export function useDeleteGenotyping() {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => genotypingController.deleteGenotyping(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getGenotypingList', farmId] })
      toastSyncSuccess('Genotipagem excluída com sucesso!')
    },
    onError: () => {
      toast.error('Erro ao excluir genotipagem')
    }
  })
}
